module.exports = __webpack_public_path__ + "media/images/icons/outlined/save-c26a4225d7a7761030fe1f7f532a4a2c.svg";